import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

GSAP.registerPlugin(ScrollTrigger, SplitText)

export default class TitleAnimation {
	constructor(el) {

		this.element 	= el
		this.title 		= this.element.querySelector('h2')

		if (this.title && this.element) {
			const letters 	= new SplitText(this.title, { type: 'chars,words' });

			const tl = GSAP.timeline({
				scrollTrigger: {
					trigger: this.element,
					start: 'top 75%',
					end: '+=50%',
					pin: false,
					scrub: true
				}
			})
			.set(letters.chars, {
				// className: 'highlight',
				color: 'var(--color-light)',
				stagger: 0.1,
			}, 0.1);
		}
	}

}
